export const errorsConfig = {
    "tableDefinition": {
        "tooltip": "",
        "columns": [
            {
                "name": "description",
                "label": "Description",
                "displayField": "atext"
            },
            {
                "name": "created",
                "label": "Created",
                "displayField": "acreated"
            }
        ]
    }
}